import { Route } from 'RestAPIs/travel-distances/types';

import { displayNumber } from 'utils/misc';

import { Dialog } from 'components/shared';

import { getAddressAsString } from '../util';
import { useCallback, useLayoutEffect, useRef, useState } from 'react';

type Props = {
  route: Route;
  isOpen: boolean;
  onClose: () => void;
};

const TravelDistanceMapDialog = ({ route, isOpen, onClose }: Props) => {
  const [, updateState] = useState<object>();
  const forceUpdate = useCallback(() => updateState({}), []);
  const MapView = useRef<(() => JSX.Element) | (({ route }) => JSX.Element)>(
    () => <>NODE_ENV_MAPVIEW_PLACEHOLDER</>
  );

  const onClickCancel = () => {
    onClose();
  };

  // Conditionally load AzureMaps lazily to circumvent AzureMaps calling client-side JS functions
  // that do not exist in a NodeJS environment (i.e. when running Jest tests)
  // Note that React's lazy() cannot be used due to conflicts with react-router
  useLayoutEffect(() => {
    import('./MapView').then((module) => {
      MapView.current = module.default;
      forceUpdate();
    });
  }, [window]);

  return (
    <Dialog
      open={isOpen}
      title={
        route
          ? getAddressAsString(route.departureAddress) +
            ' - ' +
            getAddressAsString(route.destinationAddress) +
            ' (' +
            displayNumber(route.distanceInMeters / 1000, 1) +
            'km)'
          : ''
      }
      handleClose={onClickCancel}
      fullWidth={true}
      maxWidth="xl"
      PaperProps={{ sx: { width: '100%', height: '100%' } }}
    >
      <MapView.current route={route} />
    </Dialog>
  );
};

export default TravelDistanceMapDialog;
